module.exports = __webpack_public_path__ + "static/media/moschino_logo.9437dd88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/moschino_logo.jpg
// module id = 740
// module chunks = 0